import { Card } from "react-bootstrap";

const SmallCards2 = ({ title, number }) => {
  return (
    <Card bg="dark1" className="h-100">
      <Card.Body className="text-light">
        <b className="m-0">{title}</b>
        <p className="mb-0">{number}</p>
      </Card.Body>
    </Card>
  );
};

export default SmallCards2;
